import { SectionImage } from 'services/api/vehicle-sections/types';
import { useExteriorSectionData } from './useExteriorSection';
import { useGetVehicleId } from 'pages/CreateVehicle/hooks/useGetVehicleId';
import { useGetSectionsQuery } from 'services/api/vehicle-sections';
import { skipToken } from '@reduxjs/toolkit/query';

export const useOBDImages = (): {
  smogImages: SectionImage[];
  vinImage: SectionImage | undefined;
  plateImage: SectionImage | undefined;
} => {
  const { images: tiresImages } = useExteriorSectionData('tires');

  const vehicleId = useGetVehicleId();
  const { data: sections } = useGetSectionsQuery(vehicleId || skipToken);

  const section = (sections as any)?.interior_questions?.subsections?.odb_check_smog_readiness;
  const smogImages: SectionImage[] = (section?.images || []).filter((img: SectionImage) => !!img.url);
  const vinImage = tiresImages.find(img => img.type === 'tires.vin_plate');
  const plateImage = tiresImages.find(img => img.type === 'tires.license_plate_registration');

  return { smogImages, vinImage, plateImage };
};
